// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-6e187fce]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.live_coupon_content .label[data-v-6e187fce] {\n  margin-bottom: 10px;\n}\n.live_coupon_content .warn[data-v-6e187fce] {\n  color: #999;\n  margin: 10px 0;\n}", ""]);
// Exports
module.exports = exports;
